import PropTypes from 'prop-types';

import AdyenDropIn from './AdyenDropIn';

const PaymentMethodSelector = ({
  paymentMethods,
  paymentSession,
  onSubmit,
  total,
}) => (
  <div className="flex max-w-2xl flex-col gap-4 rounded-lg py-10">
    {
        paymentMethods && paymentMethods.paymentMethods.length > 0 && (
        <AdyenDropIn
          paymentMethods={paymentMethods}
          paymentSession={paymentSession}
          onSubmit={onSubmit}
          amount={total}
          onError={(error) => console.error(`Error${error}`)}
        />
        )
      }

    <div className="flex items-end justify-center gap-6" />
  </div>
);

PaymentMethodSelector.propTypes = {
  paymentMethods: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
  }),
};

export default PaymentMethodSelector;
